import Aside from './aside';
import Util from 'Common/util';
import ds from 'Shared/ds';

export class Panel {
    constructor(parent, type) {
        this.parent = parent;
        this.type = type;
    }

    init() {
        return Promise.resolve()
    }

    visible = ko.observable(false);

    loaded = ko.observable(false);
    loading = ko.observable(false);

    delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    show = () => {
        this.parent.panelStack.push(this);

        setTimeout(() => {
            this.visible(true);
        }, 30);
    }

    hide = () => {
        this.visible(false);
        setTimeout(() => {
            this.parent.panelStack.remove(this);
        }, 500);
    }
}

export class TemplatePanel extends Panel {
    constructor(parent, templateName) {
        super(parent, 'static');

        this.template = ko.observable(templateName);
    }

    nodes = null;
}

class SelectItem {
    constructor(data, panel) {
        this.panel = panel;

        ko.mapping.fromJS(data, {}, this);
    }

    id = ko.pureComputed(() => `${this.panel.name}-${this.Id()}`);
}

export class SelectPanel extends TemplatePanel {
    constructor(parent, options) {
        super(parent, 'aside-select-panel');

        this.options = options;
        this.name = options.name;

        this.selected.subscribe(newValue => {
            if (!this.#initialized && options.changed) {
                options.changed(newValue);
            }
        })
    }

    #initialized = false;
    selected = ko.observable();

    async init() {
        this.#initialized = true;

        if (!this.loaded()) {
            this.loading(true);

            let mapping = {
                Items: {
                    key: data => data.Id,
                    create: options => new SelectItem(options.data, this)
                }
            }

            const data = await ds.get(this.options.requestUrl, this.options.params);
            ko.mapping.fromJS(data, mapping, this);

            this.loading(false);
            this.loaded(true);
        }

        if (this.options.selected) {
            const selectedItem = ko.utils.arrayFirst(this.Items(), x => x.Id() == this.options.selected());
            this.selected(selectedItem);
        } else {
            const selectedItem = ko.utils.arrayFirst(this.Items(), x => x.Selected());
            this.selected(selectedItem);
        }

        this.#initialized = false;
    }
}

export class MultiSelectPanel extends TemplatePanel {
    constructor(parent, options) {
        super(parent, 'aside-multiselect-panel');

        this.options = options;

        this.name = options.name;

        this.selected.subscribe(newValue => {
            if (!this.#initialized && options.changed) {
                options.changed(newValue);
            }
        })
    }

    #initialized = false;
    selected = ko.observableArray();

    async init() {
        this.#initialized = true;

        if (!this.loaded()) {
            this.loading(true);

            let mapping = {
                Items: {
                    key: data => data.Id,
                    create: options => new SelectItem(options.data, this)
                }
            }

            const data = await ds.get(this.options.requestUrl, this.options.params);
            ko.mapping.fromJS(data, mapping, this);

            this.loading(false);
            this.loaded(true);
        }

        if (this.options.selected) {
            const selected = ko.unwrap(this.options.selected);
            const selectedItems = ko.utils.arrayFilter(this.Items(), x => selected.find(i => i == x.Id()));
            this.selected.push(...selectedItems);
        } else {
            const selectedItems = ko.utils.arrayFilter(this.Items(), x => x.Selected());
            this.selected.push(...selectedItems);
        }

        this.#initialized = false;
    }
}

export class DynamicTemplatePanel extends Panel {
    constructor(parent, templateUrl, data) {
        super(parent, 'dynamic');

        this.templateUrl = templateUrl;
        this.data = data;
    }

    template = null;
    nodes = null;

    async init() {

        if (this.loaded()) {
            return;
        }

        if (this.templateUrl) {
            this.loading(true);

            const template = await ds.get(this.templateUrl, this.data);

            let nodes = Util.parseTemplate(template);

            let panel = document.createElement("div", {});
            panel.appendChild(nodes);

            this.nodes = panel.childNodes;

            this.loading(false);
        }

        this.loaded(true);
    }
}

export default class AsideStackPanel extends Aside {
    constructor(options, init = true) {
        super(options, init);

        this.#bindEvents();
    }

    get panelContainer() {
        return document.querySelector(`#${this.option.id} .panelcontainer`);
    }

    #bindEvents() {
        this.offcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
            this.panelStack.removeAll();
        });
    }

    loading = false;

    panelStack = ko.observableArray([]);

    showPanel = async (model, e) => {
        if (this.loading) return;

        this.loading = true;

        try {
            const panelId = e.currentTarget.dataset.panel;

            const panel = await this.getPanel(panelId);
            if (panel) {
                panel.show();
            }
        }
        finally {
            this.loading = false;
        }
    }

    async getPanel(id) {
        return null;
    }

    loaded = ko.observable(false);
}